import { default as classNames, default as classnames } from 'classnames';
import es from 'date-fns/locale/es';
import useCustomRef from 'hooks/useCustomRef';
import _ from 'lodash';
import moment from 'moment';
import { normalizeText } from 'normalize-text';
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import React, { useMemo, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Controller, useFormContext } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import Select from 'react-select';
import styled from 'styled-components';
import COLORS from 'utils/constants/COLORS';
import * as uuid from 'uuid';
import { ComboDatePicker } from '../ComboDatePicker';
import { inputNumericoEnteros } from './validaciones';

export const UniqueId = ({ name = 'uuid', hide = true }) => {
  return (
    <Controller
      name={name}
      defaultValue={uuid.v4()}
      render={({ value }) => (
        <p
          className={classNames({
            'd-none': hide,
          })}
        >
          {value}
        </p>
      )}
    />
  );
};

export const TextInput = ({
  rules,
  inputProps,
  extrasClasses,
  hideArrows = false,
  onChangeBn,
  onChangeFn,
  defaultValue = '',
  disabled = false,
}) => {
  const { focusRef, setRef } = useCustomRef();
  const memoProps = useMemo(() => {
    if (inputProps?.isNumberInt) {
      const newInputProps = {
        ...inputProps,
        type: 'number',
        onKeyDown: inputNumericoEnteros,
      };
      delete newInputProps.isNumberInt;

      return newInputProps;
    }
    return inputProps;
  }, [inputProps]);

  return (
    <Controller
      name={inputProps.name}
      rules={rules}
      onFocus={focusRef}
      defaultValue={defaultValue}
      render={({ value, onChange }) => (
        <input
          id={inputProps.name}
          name={inputProps.name}
          value={value}
          className={classnames({
            [`input-line-heigth-cero input-home-cotizacion-type1bold ${extrasClasses}`]: true,
            'hide-arrows': hideArrows,
          })}
          onChange={(evt) => {
            let value = evt.target.value;
            if (onChangeBn) {
              value = onChangeBn(evt.target.value);
            }
            onChange(value);
            onChangeFn && onChangeFn(value);
          }}
          ref={setRef}
          {...memoProps}
          onBlur={(evt) => {
            const onBlur = memoProps?.onBlur;
            if (onBlur) {
              onBlur(evt.target.value);
            }
          }}
        />
      )}
    />
  );
};

export const NumberInput = ({ rules, extrasClasses, hideArrows = false, defaultValue = null, name, ...rest }) => {
  const { control } = useFormContext();
  const { focusRef, setRef } = useCustomRef();

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      onFocus={focusRef}
      render={({ onChange, value, ref }) => (
        <InputNumber
          className="input__mask__mex"
          value={value}
          onChange={(e) => {
            onChange(e.value);
          }}
          name={name}
          style={{
            border: 'none',
            outline: 'none',
            fontFamily: 'SourceSansPro-Regular',
          }}
          ref={setRef('input')}
          inputId={name}
          {...rest}
        />
      )}
    />
  );
};

export const PrimeTextInput = ({
  rules,
  defaultValue = null,
  name,
  disabled = false,
  isUpper = false,
  onChangeFn,
  loading = false,
  ...rest
}) => {
  const { control } = useFormContext();
  const { focusRef, setRef } = useCustomRef();

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      onFocus={focusRef}
      render={({ onChange, value, ref }) => (
        <InputText
          className="input__mask__mex"
          value={value}
          onChange={(e) => {
            if (isUpper) {
              onChange(e.currentTarget.value.toUpperCase());
            } else {
              onChange(e.currentTarget.value);
            }
            onChangeFn && onChangeFn(e.currentTarget.value);
          }}
          name={name}
          style={{
            border: 'none',
            outline: 'none',
            fontFamily: 'SourceSansPro-Regular',
          }}
          id={name}
          disabled={disabled || loading}
          {...rest}
          ref={setRef}
        />
      )}
    />
  );
};

const SelectStyled = styled.select`
  width: 99%;
  border: none;
  outline: none;
  font-family: SourceSansPro-Regular, serif;
  font-size: 14px;
  color: #151515;
  padding-left: 15px;
  font-weight: 600;
  height: 32px;
`;

const Option = styled.option`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  outline: none;
  font-family: SourceSansPro-Regular, serif;
  font-size: 16px;
  color: #151515;
  padding-left: 15px;
  font-weight: 600;
  background-color: white;
`;

export const DropDown = ({
  options = [],
  callbackOnChange,
  name,
  rules,
  defaultValue = null,
  placeholder,
  includePlaceholder = true,
  loading = false,
  onChangeFn,
  optionValue = 'value',
  onBlur = () => {},
  ...props
}) => {
  const methods = useFormContext();
  const { control } = methods;

  const { focusRef, setRef } = useCustomRef();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      //defaultValue={options.length > 0 && JSON.stringify(options[0].value)}
      defaultValue={defaultValue}
      onFocus={focusRef}
      render={({ onChange, value }) => {
        return (
          <SelectStyled
            id={name}
            onBlur={onBlur}
            disabled={loading}
            onChange={({ target }) => {
              const parsedValue = JSON.parse(target.value);
              onChange(parsedValue);
              onChangeFn && onChangeFn(parsedValue, methods);
            }}
            value={JSON.stringify(value)}
            {...props}
            ref={setRef}
          >
            {includePlaceholder && (
              <Option value={JSON.stringify('')}>{loading ? 'Cargando...' : placeholder || 'SELECCIONE'}</Option>
            )}
            {loading
              ? 'Cargando...'
              : options?.map?.((option, index) => (
                  <Option key={index} value={JSON.stringify(option.value)}>
                    {loading ? 'Cargando...' : option?.label}
                  </Option>
                ))}
          </SelectStyled>
        );
      }}
    />
  );
};

export const DropDownDate = ({
  name,
  rules,
  outFormat = 'yyyy-MM-DD',
  defaultValue = null,
  onChangeFn = null,
  ...props
}) => {
  const { control, getValues } = useFormContext();
  const [, setInternal] = useState(null);
  const { focusRef, setRef } = useCustomRef();
  return (
    <React.Fragment>
      <Controller
        name={name}
        control={control}
        rules={{
          setValueAs: (value) => (value ? moment(value).format(outFormat) : value),
          ...rules,
        }}
        defaultValue={getValues(name)}
        onFocus={focusRef}
        render={({ onChange, value }) => {
          return (
            <ComboDatePicker
              id={name}
              name={name}
              date={value}
              placeholder={['Año', 'Mes', 'Día']}
              order="ymd"
              subref={setRef}
              onChange={(_picker, date) => {
                setInternal(date);
                if (
                  'invalid date' !== normalizeText(String(date)).toLowerCase() &&
                  'fecha invalida' !== normalizeText(String(date)).toLowerCase() &&
                  date !== null &&
                  date !== '' &&
                  date !== undefined
                ) {
                  console.log('DATE: ', date);
                  onChange(date);
                  onChangeFn && onChangeFn(date);
                } else {
                  onChange(null);
                }
              }}
              attrsDate={{ disabled: props?.disabled || props?.loading }}
              attrsMonth={{ disabled: props?.disabled || props?.loading }}
              attrsYear={{ disabled: props?.disabled || props?.loading }}
              {...props}
            />
          );
        }}
      />
    </React.Fragment>
  );
};

export const TextInputMask = ({
  name,
  rules,
  mask = '999999',
  //unmask = true,
  unmask = true,
  replaces = [],
  defaultValue = null,
  ...props
}) => {
  const { control } = useFormContext();
  const { focusRef, setRef } = useCustomRef();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      onFocus={focusRef}
      render={({ onChange, value, ref }) => (
        <InputMask
          className="input__mask__mex"
          mask={mask}
          name={name}
          value={value}
          autoClear={false}
          onChange={(e) => {
            onChange(e.value);
          }}
          unmask={unmask}
          style={{
            border: 'none',
            outline: 'none',
            fontFamily: 'SourceSansPro-Regular',
          }}
          {...props}
          id={name}
          ref={setRef('input')}
        />
      )}
    />
  );
};

/** @type {import("react-select").StylesConfig} */
const customStylesDropDown = {
  menu: (provided, state) => ({
    ...provided,
    color: state.selectProps.menuColor,
    marginLeft: '-1em',
    borderRadius: '0',
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    fontWeigth: 'bold',
    color: '#6c757d',
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    fontWeigth: 'bold',
    height: '32px',
    minHeight: '32px',
    padding: '0px 8px',
  }),
  control: (styles) => ({
    ...styles,
    border: 'none',
    boxShadow: 'none',
    borderRadius: '0',
    height: '32px',
    minHeight: '32px',
    backgroundColor: 'white',
  }),
  input: (styles) => ({
    ...styles,
    height: '32px',
    minHeight: '32px',
    margin: '0px',
  }),
  container: (styles) => ({
    ...styles,
    height: '32px',
    minHeight: '32px',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = '#001871';
    return {
      ...styles,
      color: 'black',
      backgroundColor: isDisabled ? null : isSelected ? data.color : isFocused ? '#e9ecef' : null,
      ':hover': {
        ...styles[':hover'],
        backgroundColor: !isDisabled && (isSelected ? data.color : color),
        color: 'white',
      },
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? data.color : color),
        color: 'white',
      },
    };
  },
};

/**
 * @description Este componente de <Select/> no es sencible al undefined, no le toma como null
 * @param {*} param0
 * @returns
 */
export const DropDownFilter = ({
  name,
  rules,
  optionLabel = 'label',
  optionValue = 'value',
  options = [],
  onChangeFn,
  dataKey,
  loading,
  defaultValue = null,
  placeholder = 'SELECCIONE',
  loadingText = 'BUSCANDO...',
  helpText,
  filter = true,
  disabled = false,
  isClearable = false,
  onChangeBn,
  emptyFilterMessage = 'NO SE HA ENCONTRADO INFORMACIÓN',
  stylesDropDown = customStylesDropDown,
  ...props
}) => {
  const { control } = useFormContext();

  const { focusRef, setRef } = useCustomRef(null);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        onFocus={focusRef}
        render={({ onChange, value, ref }) => {
          return (
            <React.Fragment>
              <Select
                inputId={name}
                isClearable={isClearable}
                isSearchable
                isDisabled={disabled || loading}
                isLoading={loading}
                noOptionsMessage={() => emptyFilterMessage}
                loadingMessage={() => {
                  return 'Buscando...';
                }}
                name={name}
                options={[...options]}
                ref={setRef('select')}
                value={value}
                onChange={(evt) => {
                  onChangeBn && onChangeBn(evt);
                  if (evt) {
                    onChange(evt?.value);
                    onChangeFn && onChangeFn(evt?.value);
                  } else {
                    onChange(null);
                    onChangeFn && onChangeFn(null);
                  }
                }}
                placeholder={loading ? loadingText : placeholder}
                styles={stylesDropDown}
              />
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};

/**
 *
 * @param {{name:string, defaultValue:any, rules:Exclude<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>}} param0
 * @returns
 */
export const HideField = ({ name, defaultValue, rules = {}, show = false }) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      render={({ value }) => (
        <span hidden={!show}>
          NAME: {name}
          <br />
          RULES: {JSON.stringify(rules)}
          <br />
          VALUE: {JSON.stringify(value)}
          <br />
        </span>
      )}
    />
  );
};

export const ObjectViewPathField = ({ name, defaultValue, rules = {}, path }) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      render={({ value }) => {
        return (
          <InputText
            className="input__mask__mex"
            defaultValue={path ? _.get(value, path, '') : value}
            name={name}
            style={{
              border: 'none',
              outline: 'none',
              fontFamily: 'SourceSansPro-Regular',
            }}
            readOnly
            id={name}
          />
        );
      }}
    />
  );
};

export const TextInputOnBlur = ({
  rules,
  inputProps,
  extrasClasses,
  allowNegative = false,
  isUpper = false,
  hideArrows = false,
  defaultValue = null,
  sufijo = '',
  prefijo = '',
  disabled = false,
  onBlur = () => {},
  onChangeFn = () => {},
  numerico = false,
  thousandSeparator = true,
  decimalScale = 2,
}) => {
  const { register, control } = useFormContext();
  const { focusRef } = useCustomRef(null);

  const memoProps = useMemo(() => {
    if (inputProps.isNumberInt) {
      const newInputProps = {
        ...inputProps,
        type: 'number',
        onKeyDown: inputNumericoEnteros,
      };
      delete newInputProps.isNumberInt;

      return newInputProps;
    }
    return inputProps;
  }, [inputProps]);

  return (
    <Controller
      control={control}
      name={inputProps.name}
      rules={rules}
      defaultValue={defaultValue}
      onFocus={focusRef}
      render={({ onChange, value, ref }) => {
        return (
          <React.Fragment>
            {numerico && (
              <NumberFormat
                id={inputProps?.name}
                defaultValue={defaultValue}
                allowNegative={allowNegative}
                suffix={sufijo}
                prefix={prefijo}
                onBlur={onBlur}
                thousandSeparator={thousandSeparator}
                decimalScale={decimalScale}
                readOnly={disabled}
                onValueChange={(v) => {
                  onChange(v.value !== '' ? v.value * 1 : null);
                  onChangeFn(v.value !== '' ? v.value * 1 : null);
                }}
                value={value !== null && value !== undefined ? value * 1 : ''}
                className={`w-100 border-0 input-line-heigth-cero input-home-cotizacion-type1bold ${extrasClasses}`}
              />
            )}
            {!numerico && (
              <input
                id={inputProps.name}
                readOnly={disabled}
                onBlur={onBlur}
                className={classNames({
                  [`input-line-heigth-cero input-home-cotizacion-type1bold ${extrasClasses}`]: true,
                  'hide-arrows': hideArrows,
                })}
                value={value}
                // ref={register(rules)}
                {...memoProps}
                defaultValue={defaultValue}
                onChange={(e) => {
                  if (isUpper) {
                    onChange(e.target.value.toUpperCase());
                    onChangeFn(e.target.value.toUpperCase());
                  } else {
                    onChange(e.target.value);
                    onChangeFn(e.target.value);
                  }
                }}
              />
            )}
          </React.Fragment>
        );
      }}
    />
  );
};
export const ControllerWrapper = ({ name, defaultValue, rules = {}, children }) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      render={({ name, onChange, ref, value }) => {
        React.Children(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(children, { name, onChange, ref, value });
          }
          return child;
        });
      }}
    />
  );
};

export const BaseButton = styled.button`
  border: none;
  outline: none;
  width: 100%;
  color: ${(props) => props.textColor || COLORS.primary};
  background-color: ${(props) => props.bgColor || 'white'};
  height: 60px;
  font-size: 20px;
  text-transform: uppercase;
  cursor: pointer;
  font-family: 'Futura-Medium', Arial, Helvetica, sans-serif;
`;

export const SeleccionarFecha = ({
  name = '',
  rules,
  fechaInicio,
  fechaFin,
  placeholder,
  preload = null,
  dateFormat = "EEEE, dd 'de' MMMM 'del' yyyy",
}) => {
  const { control } = useFormContext();
  registerLocale('es', es);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ onChange, value = preload }) => {
          return (
            <React.Fragment>
              <DatePicker
                locale="es"
                selected={value}
                onChange={(date) => onChange(date)}
                minDate={new Date(fechaInicio)}
                maxDate={new Date(fechaFin)}
                placeholderText={placeholder}
                className="picker"
                isClearable
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                onChangeRaw={(e) => {
                  e.preventDefault();
                }}
                dateFormat={dateFormat}
              />
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};

export const ControllerRender = ({
  name,
  defaultValue,
  rules = {},
  render = ({ name, onChange, ref, value }) => {},
}) => {
  return <Controller name={name} defaultValue={defaultValue} rules={rules} render={(field) => render({ ...field })} />;
};

const customStylesDropDownRCP = {
  menu: (provided, state) => ({
    ...provided,
    color: state.selectProps.menuColor,
    marginLeft: '-1em',
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    fontWeigth: 'bold',
    color: '#6c757d',
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    fontWeigth: 'bold',
  }),
  control: (styles) => ({
    ...styles,
    border: 'none',
    boxShadow: 'none',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = '#001871';
    return {
      ...styles,
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? data.color : color),
        color: 'white',
      },
    };
  },
};

/**
 * @description Este componente de <Select/> no es sencible al undefined, no le toma como null
 * @param {*} param0
 * @returns
 */
export const DropDownFilterRCP = ({
  name,
  rules,
  onSelect = () => {},
  optionLabel = 'label',
  optionValue = 'value',
  options = [],
  onChangeFn = null,
  dataKey,
  loading,
  disabled = false,
  defaultValue = null,
  placeholder = 'SELECCIONE',
  loadingText = 'BUSCANDO...',
  helpText,
  filter = true,
  emptyFilterMessage = 'NO SE HA ENCONTRADO INFORMACIÓN',
  value,
  ...props
}) => {
  const { control } = useFormContext();
  const objectPath = require('object-path');

  const opciones = options?.map((option) => ({
    label: objectPath.get(option, optionLabel),
    value: objectPath.get(option, optionValue),
  }));

  const { setRef } = useCustomRef(null);

  const internalPlaceHolder = useMemo(() => (loading ? loadingText : placeholder), [loading, placeholder, loadingText]);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ onChange, value, ref }) => {
          const label = opciones?.find((item) => JSON.stringify(item?.value) === JSON.stringify(value))?.label;
          let normalizado = {
            label,
            value,
          };

          let esValido = normalizado.label && normalizado.value;

          if (!esValido && !!defaultValue) {
            normalizado = {
              label: defaultValue.label,
              value: defaultValue,
            };
            esValido = true;
          }

          return (
            <React.Fragment>
              <Select
                className="w-100"
                id={name}
                defaultValue={defaultValue}
                isClearable={true}
                isSearchable={true}
                isDisabled={loading || disabled}
                isLoading={loading}
                noOptionsMessage={() => emptyFilterMessage}
                loadingMessage={() => {
                  return 'Buscando...';
                }}
                value={esValido ? normalizado : internalPlaceHolder}
                name={name}
                options={opciones}
                ref={setRef('select')}
                onChange={(evt) => {
                  if (evt) {
                    onChange(evt?.value);
                    onChangeFn && onChangeFn(evt.value ? evt.value : '', name);
                    onSelect(evt.value ? evt.value : '');
                  } else {
                    onChange(null);
                    onChangeFn && onChangeFn(null);
                  }
                }}
                placeholder={internalPlaceHolder}
                styles={customStylesDropDownRCP}
              />
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};
